/* Petuno horizontal product carousel: native scroll-snap + optional arrow buttons. */
if (!customElements.get('petuno-carousel')) {
  class PetunoCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-pt-track]');
      if (!this.track) return;
      this.prevBtn = this.querySelector('[data-pt-prev]');
      this.nextBtn = this.querySelector('[data-pt-next]');
      this.onScroll = () => this.update();
      this.onPrev = () => this.scrollView(-1);
      this.onNext = () => this.scrollView(1);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      if (this.prevBtn) this.prevBtn.addEventListener('click', this.onPrev);
      if (this.nextBtn) this.nextBtn.addEventListener('click', this.onNext);
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.onScroll);
        this.resizeObserver.observe(this.track);
      } else {
        window.addEventListener('resize', this.onScroll);
      }
      this.update();
    }

    disconnectedCallback() {
      if (!this.track) return;
      this.track.removeEventListener('scroll', this.onScroll);
      if (this.prevBtn) this.prevBtn.removeEventListener('click', this.onPrev);
      if (this.nextBtn) this.nextBtn.removeEventListener('click', this.onNext);
      if (this.resizeObserver) this.resizeObserver.disconnect();
      else window.removeEventListener('resize', this.onScroll);
    }

    scrollView(direction) {
      const slide = this.track.querySelector('[data-pt-slide]');
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = slide ? slide.getBoundingClientRect().width + gap : this.track.clientWidth * 0.8;
      const visible = Math.max(1, Math.floor(this.track.clientWidth / step));
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({ left: direction * step * visible, behavior: reduce ? 'auto' : 'smooth' });
    }

    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const left = Math.round(this.track.scrollLeft);
      if (max <= 2) this.setAttribute('data-static', '');
      else this.removeAttribute('data-static');
      if (this.prevBtn) this.prevBtn.disabled = left <= 2;
      if (this.nextBtn) this.nextBtn.disabled = left >= max - 2;
    }
  }
  customElements.define('petuno-carousel', PetunoCarousel);
}